var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkillTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6276 31.9995H2.37242C1.05992 31.9995 0 30.9339 0 29.6245V6.34379C0 5.02984 1.06443 3.96875 2.37242 3.96875H25.6276C26.9401 3.96875 28 5.03436 28 6.34379V29.6245C28 30.9385 26.9401 31.9995 25.6276 31.9995Z",
    fill: "url(#paint0_linear_995_190)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.532 2.26667C16.3922 0.993368 15.3142 0 14.0017 0C12.6892 0 11.6113 0.993368 11.4715 2.26667H9.07649C7.8542 2.26667 6.85742 3.26003 6.85742 4.48818V4.57849C6.85742 5.80213 7.84969 6.8 9.07649 6.8H18.927C20.1493 6.8 21.1461 5.80664 21.1461 4.57849V4.48818C21.1461 3.26454 20.1538 2.26667 18.927 2.26667H16.532Z",
    fill: "#4BB7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83738 12.2543C6.83738 11.428 6.16986 10.7598 5.34447 10.7598C4.51909 10.7598 3.85156 11.428 3.85156 12.2543C3.85156 13.0806 4.51909 13.7489 5.34447 13.7489C6.16986 13.7489 6.83738 13.0806 6.83738 12.2543Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76758 26.293H22.2302",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76758 22.5957H22.2302",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_995_190",
    x1: 23.129,
    y1: 33.8132,
    x2: 4.84097,
    y2: 2.17211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BB7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillTitleIcon);
export default __webpack_public_path__ + "static/media/skill_title_icon.3f2c1f0f2f8f5c4b393e9d5e1943cba9.svg";
export { ForwardRef as ReactComponent };